import React, { Component } from 'react'
import { Mutation } from 'react-apollo'

import { AUTH_TOKEN, SELECTED_BRANCH } from '../../constants'
import { ACTIVATE_USER } from '../../mutations'

import Footer from '../../components/Footer/'
import LoginForm from '../../containers/LoginForm/'
import BrancheList from '../../containers/BrancheList/'

import logo from '../../assets/logo.svg'
import desert from '../../assets/hero/login/desert.jpg'
import desertMobile from '../../assets/hero/login/desert-mobile.jpg'
import rock from '../../assets/hero/login/rock.jpg'
import rockMobile from '../../assets/hero/login/rock-mobile.jpg'
import sea from '../../assets/hero/login/sea.jpg'
import seaMobile from '../../assets/hero/login/sea-mobile.jpg'
import snow from '../../assets/hero/login/snow.jpg'
import snowMobile from '../../assets/hero/login/snow-mobile.jpg'
import { Container, Logo, BranchesContainer } from './styles'

class Activate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      branches: [],
      showBranches: false
    }
  }

  async handleActivation(username, password) {
    const result = await this.activateUser({
      variables: {
        data: {
          id: this.props.match.params.id,
          username: username,
          password: password
        }
      }
    })

    const { token, user } = result.data.activateUser
    const { branches } = user
    this.saveUserData(token)
    if (branches.length > 1) {
      this.setState({ showBranches: true, branches })
    } else {
      window.localStorage.setItem(SELECTED_BRANCH, branches[0].id)
      this.props.history.push('/')
    }
  }

  saveUserData(token) {
    window.localStorage.setItem(AUTH_TOKEN, token)
  }

  handleClick(branch) {
    // this.props.login(branche)
    window.localStorage.setItem(SELECTED_BRANCH, branch)
    this.props.history.push('/')
  }

  generateRandomImage() {
    let images = [
      {
        desktop: desert,
        mobile: desertMobile
      },
      {
        desktop: rock,
        mobile: rockMobile
      },
      {
        desktop: sea,
        mobile: seaMobile
      },
      {
        desktop: snow,
        mobile: snowMobile
      }
    ]

    // randomnize
    return images[Math.floor(Math.random() * images.length)]
  }

  render() {
    const { showBranches } = this.state
    const hero = this.generateRandomImage()

    return (
      <Container overlay={showBranches} image={hero.desktop} mobile={hero.mobile}>
        <Logo src={logo} alt='logo' />

        {showBranches ? (
          <BranchesContainer>
            <BrancheList
              handleClick={this.handleClick.bind(this)}
              title='Kies uw filiaal'
              branches={this.state.branches}
            />
          </BranchesContainer>
        ) : (
          <Mutation mutation={ACTIVATE_USER}>
            {(activateUser, { data, loading, error }) => {
              this.activateUser = activateUser
              return (
                <LoginForm
                  activate
                  handleChange={this.handleChange}
                  login={this.handleActivation.bind(this)}
                  activationId={this.props.match.params.id}
                />
              )
            }}
          </Mutation>
        )}

        <Footer type='transparent' />
      </Container>
    )
  }
}

export default Activate



// WEBPACK FOOTER //
// ./src/views/Activate/index.js